import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { DropdownItemProps } from "@traveloka/district-bloom/js/components/Inputfield/component/DropdownItem";
import { useFormContext, useWatch } from "react-hook-form";
import { StyleSheet } from "react-native";
import BMDropdownInput from "../../../../../components/DropdownInput";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { SelectNonEmployeeFormValues } from "./types";

const ageDropdownItems = [
  {
    label: "<1",
    value: "<1",
  },
  ...Array.from({ length: 17 }).map((_, index) => ({
    label: (index + 1).toString(),
    value: (index + 1).toString(),
  })),
];

export default function SelectNonEmployeeChildrenAges() {
  const { CorporateProductSearchForm: cr } = useMobileContentResource();

  const { control, getValues, setValue } =
    useFormContext<SelectNonEmployeeFormValues>();
  const childrenAges = useWatch({ control, name: "childrenAges" });

  function handleAgeChange(item: DropdownItemProps, index: number) {
    const childrenAges = getValues("childrenAges");

    const newAges = [...childrenAges];
    newAges[index] = item.value;
    setValue("childrenAges", newAges, { shouldDirty: true });
  }

  return (
    <>
      {childrenAges.map((_, index, arr) => (
        <BMView
          style={[styles.container, { zIndex: arr.length - index }]}
          row
          align="center"
          justify="between"
          key={index}
        >
          <BMText variant="uiLargeLi" ink="BMStyleTextInkSecondary">
            {cr.childrenText} {index + 1}
          </BMText>
          <BMView style={styles.ageDropdown}>
            <BMDropdownInput
              placeholder={cr.childAgePlaceholder}
              items={ageDropdownItems}
              onItemSelect={(item) => handleAgeChange(item, index)}
              value={childrenAges[index].toString()}
              testID={`child-${index + 1}-age-dropdown`}
            />
          </BMView>
        </BMView>
      ))}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: BMPrimitives.BMSize.md,
    paddingRight: BMPrimitives.BMSize.md,
    paddingLeft: BMPrimitives.BMSize.xl4,
  },
  ageDropdown: {
    marginLeft: "auto",
    width: 120,
  },
});
